;(function ($) {
	function init() {
		if ($('#shipper-network-type').length) {
			//open modal
			$(window).on('load', function () {
				var modal = open_modal();
				var all_sites = modal.find('.sui-select#all-sites');
				var nonce = all_sites.data('nonce');
				var endpoint = ajaxurl + '?action=shipper_meta_search_sub_site&_wpnonce=' + nonce;

				$(all_sites).SUIselect2({
					dropdownCssClass: $('.sui-color-accessible')[0] ? 'sui-select-dropdown sui-color-accessible' : 'sui-select-dropdown',
					dropdownParent: $(modal),
					ajax: {
						url: endpoint,
						delay: 750,
						dataType: 'json',
						cache: true,
						data: function( params ) {
							var query = {
								search: params.term
							}

							return query;
						},
						processResults: function( response ) {
							if ( ! response || ! response.data ) {
								return {
									results: {}
								}
							}

							var options = response.data.map(function(option) {
								return {
									id: option.site_id,
									text: option.site_url,
								}
							});

							return {
								results: options
							}
						},
					}
				});


				$('#shipper-network-type').find('.sui-tab-item.active input[name="network_mode"]').click()
			});
			$('#shipper-network-type .sui-modal-close,' +
				' .shipper-db-prefix-modal .shipper-cancel').on('click', handle_preflight_cancel);
			$('.shipper-update-networktype').on('click', handle_update_networktype)
		}
	}

	function stop_prop(e) {
		if (e && e.preventDefault) e.preventDefault();
		if (e && e.stopPropagation) e.stopPropagation();
		return false;
	}

	/**
	 * Copy the code form preflight as the process much same
	 * @param e
	 * @returns {boolean}
	 */
	function handle_preflight_cancel(e) {
		$.post(ajaxurl, {action: 'shipper_preflight_cancel'}, function () {
			window.location.search = '?page=shipper-api';
		});
		return stop_prop(e);
	}

	function handle_update_networktype() {

		var site_id = $('select[name="site_id"]').val()
		var mode = $('input[name="network_mode"]');
		var hidden_mode = $('input:hidden[name="network_mode"]').val();

		if ( mode && mode.length ) {
			mode.each( function(key, element) {
				if ( $(element).is(':checked') ) {
					mode = $(element).val();
				}
			})
		} else {
			mode = false;
		}

		// hidden_mode is defined in import screen only. So if it's found, update mode with hidden_mode.
		mode = hidden_mode ? hidden_mode : mode;

		$.post(ajaxurl, {
			action: 'shipper_networktype_update',
			mode: mode,
			site_id: site_id
		}, function (data) {
			if (data.success === true) {
				location.reload();
			} else {
				//show error
			}
		});
	}

	function open_modal( replace_modal ) {
		var replace_modal = replace_modal ? true : false;
		var modal_id = get_modal_id();
		var focus_after_closed = this;
		var focus_when_open = undefined;
		var has_overlay_mask = false;
		var modal = get_modal();

		SUI[ replace_modal ? 'replaceModal' : 'openModal' ]( modal_id, focus_after_closed, focus_when_open, has_overlay_mask )

		return modal;
	}

	function get_modal_id() {
		return 'shipper-network-type';
	}

	function get_modal() {
		return $( '#' + get_modal_id() );
	}

	$(init());
}(jQuery))